import { LitElement, html, css } from 'lit';
import { customElement, state } from 'lit/decorators.js';

@customElement('vxc-sidebar')
export class TSideBar extends LitElement {

  static styles = css`
    :host {
      display: flex;
      min-height: 100vh;
      overflow: hidden;
    }

    .sidebar {
      width: var(--sidebar-width, 250px);
      transition: width 0.3s ease;
      background-color: #2c3e50;
      color: white;
      padding: 1rem;
      box-sizing: border-box;
      overflow: auto;
    }

    .sidebar.collapsed {
      width: 60px;
    }

    .main {
      flex: 1;
      transition: margin-left 0.3s ease;
      padding: 1rem;
      box-sizing: border-box;
    }

    .title-bar {
        display: flex;
        justify-content: space-between;
        align-items: center; 
    }


    .toggle-button {
      background: none;
      border: none;
      color: white;
      font-size: 1.2rem;
      cursor: pointer;
      xmargin-bottom: 1rem;
    }

    /* Optional content reveal styles */
    .sidebar.collapsed ::slotted(*) {
      display: none;
    }

    .sidebar.collapsed #brand {
        display: none;
    }
  `

    @state() private expanded = window.innerWidth >= 768;

    connectedCallback() {
        super.connectedCallback();
        window.addEventListener('resize', this.handleResize);
    }

    disconnectedCallback() {
        window.removeEventListener('resize', this.handleResize);
        super.disconnectedCallback();
    }

    private handleResize = () => {
        const isLargeScreen = window.innerWidth >= 768;
        this.expanded = isLargeScreen;
    };

    private toggleSidebar = () => {
        this.expanded = !this.expanded;
    };

    render() {
        return html`
            <div class="sidebar ${this.expanded ? '' : 'collapsed'}">
            <div class="title-bar">
                <span id="brand">IAMIE</span>
            <button class="toggle-button" @click=${this.toggleSidebar}>
            ${this.expanded ? '☰' : '☰'}
            </button>
            </div>
            <slot name="menu"></slot>
        </div>
        <div class="main">
            <slot></slot>
        </div>
        `;
    }
}

declare global {
  interface HTMLElementTagNameMap {
    'vxc-sidebar': TSideBar;
  }
}